import { gql } from "@apollo/client";

export const LOCATION_AUTOCOMPLETE = gql`
  query autocomplete($input: String!) {
    autocomplete(
      input: $input
    ) {
      predictions {
        description,
        place_id,
      },
      success,
      messages,
    }
  }
`;

export const LOCATION_DIRECTIONS = gql`
  query directions($placeId: String!) {
    directions(
      placeId: $placeId
    ) {
      directions {
        distance {
          text,
          value,
        },
        duration {
          text,
          value,
        },
        cityName,
        locationName,
        endAddress,
        startAddress,
        position {
          lat,
          lng,
        },
        background,
        locationAddress,
        phoneNumber,
        idLocation,
      },
      availableInYourArea,
      success,
      messages,
    }
  }
`;

export const LOCATION_DIRECTIONS_V2 = gql`
  query directionsV2($input: PaginatedDirectionsInputV2! ) {
    directionsV2(
      input: $input
    ) {
      totalPages,
      directions {
        distance {
          text,
          value,
        },
        duration {
          text,
          value,
        },
        cityName,
        locationName,
        isOnlyUrgentVisit,
        endAddress,
        startAddress,
        position {
          lat,
          lng,
        },
        background,
        locationAddress,
        phoneNumber,
        idLocation,
      },
      availableInYourArea,
      success,
      messages,
    }
  }
`;

export const FORMATTED_LOCATION = gql`
  query getFormattedAddress($placeId: String!) {
    getFormattedAddress(
      placeId: $placeId
      ) {
        streetAddress,
        townCity,
        zipCode,
        country,
      }
  }
`;

